export default () => {
    return [
        {
            path: '/referrals',
            name: 'referrals',
            component: () => import('./views/referrals.vue'),
        },
    ];
};
